module.exports = __webpack_public_path__ + "assets/img/ZT8211-M.24a6522d.png";